import type { Locale } from './i18n-config';
/**
 * 获取字典
 * @param paths 路径
 * @returns 字典
 */
export const getDictionary = async (paths: string | string[]) => {
  // 如果 paths 是字符串，直接返回字典内容
  if (typeof paths === 'string') {
    const dictModule = await import(`../dictionaries/${paths}.json`);
    return dictModule.default;
  }

  // 如果 paths 是数组，保持原有逻辑
  const pathArray = paths;

  const dictionaries = await Promise.all(
    pathArray.map(path =>
      import(`../dictionaries/${path}.json`).then(module => ({
        [path.split('/').pop() as string]: module.default,
      })),
    ),
  );
  return Object.assign({}, ...dictionaries);
};

/**
 * 获取语言字典
 * @param params 语言参数
 * @param paths 路径
 * @returns 语言字典
 */
export const getLanguage = async (
  params: Promise<{ lang: Locale }>,
  paths: string | string[],
) => {
  const { lang } = await params;
  const pathArray = Array.isArray(paths)
    ? paths.map(path => `${lang}/${path}`)
    : `${lang}/${paths}`;

  return getDictionary(pathArray);
};

/**
 * 参数转换方法，用于处理字典中的模板字符串
 * @param template 模板字符串，例如 "周{day}"
 * @param params 参数对象，例如 {day: '五'}
 * @returns 替换后的字符串，例如 "星期五"
 */
export const interpolate = (
  template: string,
  params: Record<string, any>,
): string => {
  return template?.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
    return params[key] !== undefined ? String(params[key]) : match;
  });
};

export const getLang = () => {
  return document.documentElement.lang as Locale;
};

export const getClientTranslateData = async (paths: string | string[]) => {
  return await getLanguage(Promise.resolve({ lang: getLang() }), paths);
};

export const getServerTranslateData = async (
  params: Promise<{ lang: Locale }>,
  paths: string | string[],
) => {
  return await getLanguage(params, paths);
};
